import DOMPurify from 'dompurify';

export const sanitizeLottieName = (name: string): string => {
    // Allow alphanumeric characters, dashes, and underscores.
    // This prevents characters that could be used for XSS in element IDs or attributes.
    return name.replace(/[^a-zA-Z0-9-_]/g, '');
};

export const sanitizeUrl = (url: string | undefined): string => {
    if (!url) {
        return '';
    }
    return DOMPurify.sanitize(url, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};
